import { component, OnDestroy } from '@smoovy/component';
import { listenCompose, listenEl, Unlisten } from '@smoovy/event';

import svcs from '../services';
import { IPlayer, PlayerEvent } from './player';

type ChangeListener = (player?: IPlayer, oldPlayer?: IPlayer) => void;

@component({
  selector: '.player-global'
})
export class PlayerGlobal implements OnDestroy {
  private activePlayer?: IPlayer;
  private unlisten?: Unlisten;
  private updateStateTimeout: any = -1;
  private listeners: ChangeListener[] = [];

  constructor(
    protected element: HTMLElement
  ) {
    this.init();
  }

  private async init() {
    const emitter = await svcs.player.service;

    this.unlisten = listenCompose(
      emitter.on<IPlayer>(PlayerEvent.PLAY, (player) => {
        this.listeners.forEach(listener => {
          listener(player, this.activePlayer);
        });

        if (this.activePlayer) {
          this.activePlayer.pause();
        }

        this.activePlayer = player;

        this.updateState();
      }),
      emitter.on<IPlayer>(PlayerEvent.PAUSE, (player) => {
        this.listeners.forEach(listener => {
          listener(undefined, this.activePlayer);
        });

        if (player === this.activePlayer) {
          this.activePlayer = undefined;
        }

        this.updateState();
      }),
      listenEl(this.element, 'click', () => {
        if (this.activePlayer) {
          this.activePlayer.pause();
        }
      })
    );
  }

  public onChange(cb: ChangeListener): Unlisten {
    this.listeners.push(cb);

    return () => {
      const index = this.listeners.indexOf(cb);

      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  private updateState() {
    if (this.updateStateTimeout) {
      clearTimeout(this.updateStateTimeout);
    }

    this.updateStateTimeout = setTimeout(() => {
      this.element.classList.toggle('is-playing', !!this.activePlayer);
    }, 50);
  }

  public onDestroy() {
    if (this.unlisten) {
      this.unlisten();
      delete this.unlisten;
    }
  }
}